import { combineReducers } from "redux";
import { configurationRootReducer } from "./configurationRootReducer";
import { ROOT_STATE_KEY } from "./constants";
/**
 * We wrap the reducer in an additional root reducer to ensure compatibility with a parent store
 */
export const rootReducer = combineReducers({
    [ROOT_STATE_KEY]: configurationRootReducer,
});
//# sourceMappingURL=rootReducer.js.map